import React, { Component } from 'react';
import './Footer.less';

const isEziot = window.location && window.location.host.indexOf('eziot.com') !== -1;

class Footer extends Component {
  render() {
    const { theme } = this.props;
    // eziot底部
    return (
      <div class="footer">
        <div class="wrapper">
          <div class="hikvision"></div>©2013-{new Date().getFullYear()}&nbsp;萤石云IOT平台版权所有&nbsp;|&nbsp;
        <a href="http://beian.miit.gov.cn/publish/query/indexFirst.action" class="serviceTerm" target="_blank">浙ICP备16009593号-3</a>&nbsp;|&nbsp;
        <a href="https://mfs.ys7.com/mall/c113d651d7d798da7d1b5bf306b4d016.jpg" class="serviceTerm" target="_blank">营业执照</a>&nbsp;|&nbsp;
        <a href="https://service.ys7.com/policy?id=200" class="serviceTerm" target="_blank">使用条款</a>&nbsp;|&nbsp;
        <a href="https://service.ys7.com/policy?id=140" class="serviceTerm" target="_blank">隐私政策</a>
        </div>
      </div>
    )

  }
}
export default Footer;
